import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from 'constants/RoutePaths';
import { useAuthContext } from 'hooks/useAuthContext';

interface AuthGuardProps {
  requiredRoles: string[];
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ requiredRoles, children }) => {
  const { userState } = useAuthContext();
  const navigate = useNavigate();


  if (userState.loading) {
    return null;
  }

  if (!userState.isAuthenticated || !userState.user.userId) {
    navigate(RoutePaths.LOGIN);
  }

  const hasRequiredRole = requiredRoles.some((role) => role === userState.user.selectedWorkspace.userRole);

  if (!hasRequiredRole) {
    navigate(RoutePaths.UNAUTHORIZED);
  }

  return <>{children}</>;
};

export default AuthGuard;
